module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAABCAMAAABjanI6AAAABlBMVEU7wLz19/lZ+NuhAAAAGUlEQVR42r3BAQ0AAACCMOhf2hKOH3uc2RuM7ADnFw5QHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/bd1.png
// module id = zAZ4
// module chunks = 0